(function(){
 'use strict';
  
 function initDarkMode(){
 var saved = localStorage.getItem('limsa-theme');
 if(saved) document.documentElement.setAttribute('data-theme', saved);
 var btn = document.querySelector('.limsa-theme-toggle');
 if(!btn) return;
 btn.addEventListener('click', function(){
 var current = document.documentElement.getAttribute('data-theme');
 var next = current === 'dark' ? 'light' : 'dark';
 document.documentElement.setAttribute('data-theme', next);
 localStorage.setItem('limsa-theme', next);
 });
 }
  
 function initZoom(){
 if(window.innerWidth < 990) return;

 var oldCloud = document.getElementById('limsa-zoom-float');
 if(oldCloud) oldCloud.remove();

 var cloud = document.createElement('div');
 cloud.id = 'limsa-zoom-float';
 cloud.className = 'limsa-zoom-cloud-float';
 document.body.appendChild(cloud);

 var mediaItems = document.querySelectorAll('.product__media-item .product__modal-opener--image, .product__media-item .product__media-toggle');
 if(!mediaItems.length) return;

 mediaItems.forEach(function(opener){
  var img = opener.querySelector('img');
  if(!img) return;

  var existingLens = opener.querySelector('.limsa-zoom-lens');
  if(existingLens) existingLens.remove();
  var lens = document.createElement('div');
  lens.className = 'limsa-zoom-lens';
  opener.style.position = 'relative';
  opener.appendChild(lens);

  opener.addEventListener('mousemove', function(e){
   var rect = opener.getBoundingClientRect();
   var x = e.clientX - rect.left;
   var y = e.clientY - rect.top;

   // lens: pink rectangle, proportional to image (≈ 30% of container each side)
   var lw = Math.round(rect.width * 0.22);
   var lh = Math.round(rect.height * 0.22);
   var lx = Math.max(0, Math.min(x - lw, rect.width - lw*2));
   var ly = Math.max(0, Math.min(y - lh, rect.height - lh*2));

   lens.style.display = 'block';
   lens.style.left = lx + 'px';
   lens.style.top = ly + 'px';
   lens.style.width = (lw*2) + 'px';
   lens.style.height = (lh*2) + 'px';

   // cloud: match SOURCE image aspect ratio (9:16, 3:4, etc.)
   var natW = img.naturalWidth  || img.width  || 600;
   var natH = img.naturalHeight || img.height || 800;
   var imgRatio = natH / natW; // portrait → > 1

   // Cap cloud width: max 360px, max available space to the right of image
   var availableRight = window.innerWidth - rect.right - 24;
   if(availableRight < 120){
    cloud.style.display = 'none';
    return;
   }
   var cw = Math.min(360, availableRight);
   var ch = Math.round(cw * imgRatio);
   // cap height to viewport
   if(ch > window.innerHeight - 20){
    ch = window.innerHeight - 20;
    cw = Math.round(ch / imgRatio);
   }

   // position cloud to the right of image, vertically centred at cursor
   var cloudTop = rect.top + y - (ch / 2);
   if(cloudTop < 10) cloudTop = 10;
   if(cloudTop + ch > window.innerHeight - 10) cloudTop = window.innerHeight - ch - 10;

   cloud.style.display = 'block';
   cloud.style.position = 'fixed';
   cloud.style.top = cloudTop + 'px';
   cloud.style.left = (rect.right + 16) + 'px';
   cloud.style.width = cw + 'px';
   cloud.style.height = ch + 'px';

   var src = img.currentSrc || img.src;
   if(src.indexOf('width=') > -1) src = src.replace(/width=\d+/, 'width=2000');

   // magnification: how much bigger is the cloud vs the lens
   var rx = cw / (lw * 2);
   var ry = ch / (lh * 2);
   // full image would be rendered at rect.width*rx × rect.height*ry
   cloud.style.backgroundImage = 'url(' + src + ')';
   cloud.style.backgroundSize = Math.round(rect.width * rx) + 'px ' + Math.round(rect.height * ry) + 'px';
   cloud.style.backgroundPosition = '-' + Math.round(lx * rx) + 'px -' + Math.round(ly * ry) + 'px';
  });

  opener.addEventListener('mouseleave', function(){
   lens.style.display = 'none';
   cloud.style.display = 'none';
  });
 });
 }
  
 function initStickyBar(){
 var bar = document.querySelector('.limsa-sticky-bar');
 if(!bar) return;
 var form = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');
 if(!form) return;
 
 function checkVisibility(){
 var rect = form.getBoundingClientRect();
 var isVisible = rect.top < window.innerHeight && rect.bottom > 0;
 bar.classList.toggle('visible', !isVisible); /* 16.09: altta da goster */
 }
 
 window.addEventListener('scroll', checkVisibility, {passive: true});
 checkVisibility();
 
 var barBtn = bar.querySelector('.bar-btn');
 if(barBtn){
 barBtn.addEventListener('click', function(){
 var mainBtn = document.querySelector('.product-form__submit');
 if(mainBtn) mainBtn.click();
 });
 }
 }
  
 window.limsaToast = function(msg, duration){
 duration = duration || 3000;
 var el = document.querySelector('.limsa-toast');
 if(!el){
 el = document.createElement('div');
 el.className = 'limsa-toast';
 document.body.appendChild(el);
 }
 el.textContent = msg;
 el.classList.add('show');
 setTimeout(function(){ el.classList.remove('show'); }, duration);
 };
  
 function initSpecsDrawer(){
 var toggles = document.querySelectorAll('.limsa-specs-toggle');
 toggles.forEach(function(btn){
 btn.addEventListener('click', function(){
 var drawer = btn.nextElementSibling;
 if(!drawer) return;
 var isOpen = drawer.classList.contains('open');
 drawer.classList.toggle('open');
 btn.classList.toggle('open');
 btn.querySelector('.toggle-text').textContent = isOpen ? 'Show All Specifications' : 'Show Less';
 });
 });
 }
  
 function initSizeChart(){
 var links = document.querySelectorAll('.limsa-size-chart-link');
 var overlay = document.querySelector('.limsa-sc-overlay');
 if(!overlay) return;
 links.forEach(function(link){
 link.addEventListener('click', function(e){
 e.preventDefault();
 overlay.classList.add('active');
 document.body.style.overflow = 'hidden';
 });
 });
 var closeBtn = overlay.querySelector('.limsa-sc-close');
 if(closeBtn){
 closeBtn.addEventListener('click', function(){
 overlay.classList.remove('active');
 document.body.style.overflow = '';
 });
 }
 overlay.addEventListener('click', function(e){
 if(e.target === overlay){
 overlay.classList.remove('active');
 document.body.style.overflow = '';
 }
 });
 }
  
 function initCartFeedback(){
 document.addEventListener('submit', function(e){
 var form = e.target;
 if(!form.matches('[data-type="add-to-cart-form"]')) return;
 setTimeout(function(){
 window.limsaToast('Added to cart');
 }, 400);
 });
 }
  
 function initColorStory(){
  var COLOR_MAP = {
   'pink':    'Confident and feminine — pink suits those who don\'t need to announce themselves twice.',
   'blush':   'Softer than pink, warmer than white. Blush is the colour of careful choices.',
   'black':   'The perennial choice for events where being remembered matters.',
   'red':     'For those who have decided.',
   'navy':    'Authoritative without loudness. Navy is the choice that ages well in every photograph.',
   'white':   'Clarity. Not simplicity — clarity. The ones who wear white know the room.',
   'ivory':   'Softer than white, richer than cream. Ivory asks for nothing and gives everything.',
   'emerald': 'Rare and self-assured. Emerald green is for the woman who can hold a room without raising her voice.',
   'sage':    'Measured. Botanical. Sage is for those who find beauty in understatement.',
   'champagne':'Neither gold nor white — champagne sits between occasions, equally at home in all of them.'
  };

  var tooltip = document.createElement('div');
  tooltip.id = 'limsa-color-story-tip';
  tooltip.style.cssText = [
   'position:fixed;z-index:9999;max-width:240px;padding:12px 16px;',
   'background:var(--panel-bg,#fff);border:1px solid var(--panel-line,#e5e0d8);',
   'box-shadow:0 8px 32px rgba(0,0,0,0.12);font-family:DM Sans,sans-serif;',
   'font-size:12px;line-height:1.65;color:var(--ld-muted,#6b6560);',
   'font-style:italic;border-radius:2px;pointer-events:none;',
   'opacity:0;transition:opacity 0.2s ease;'
  ].join('');
  document.body.appendChild(tooltip);

  function getColorKey(swatch){
   var name = (swatch.getAttribute('data-color-name') ||
               swatch.getAttribute('title') ||
               swatch.getAttribute('aria-label') ||
               swatch.textContent || '').toLowerCase().trim();
   for(var key in COLOR_MAP){
    if(name.indexOf(key) !== -1) return key;
   }
   return null;
  }

  function showTip(swatch, key, e){
   tooltip.textContent = COLOR_MAP[key];
   tooltip.style.opacity = '1';
   moveTip(e);
  }
  function moveTip(e){
   var x = e.clientX + 14;
   var y = e.clientY - 20;
   if(x + 256 > window.innerWidth) x = e.clientX - 256;
   tooltip.style.left = x + 'px';
   tooltip.style.top  = y + 'px';
  }
  function hideTip(){
   tooltip.style.opacity = '0';
  }

  document.addEventListener('mouseover', function(e){
   var swatch = e.target.closest('.swatch-variant-color,.swatch__item,[data-swatch]');
   if(!swatch) return;
   var key = getColorKey(swatch);
   if(key) showTip(swatch, key, e);
  });
  document.addEventListener('mousemove', function(e){
   if(tooltip.style.opacity === '1') moveTip(e);
  });
  document.addEventListener('mouseout', function(e){
   var swatch = e.target.closest('.swatch-variant-color,.swatch__item,[data-swatch]');
   if(swatch) hideTip();
  });
 }

 function init(){
 initDarkMode();
 initZoom();
 initStickyBar();
 initSpecsDrawer();
 initSizeChart();
 initCartFeedback();
 initColorStory();
 }
 if(document.readyState === 'loading'){
 document.addEventListener('DOMContentLoaded', init);
 } else {
 init();
 }

 if(window.Shopify && Shopify.designMode){
 document.addEventListener('shopify:section:load', function(){
  initZoom();
 });
 }
})();